import { styled } from '@mui/material/styles';
import Box, { BoxProps } from '@mui/material/Box';

interface GlassBoxProps extends BoxProps {
    blur?: number;
    opacity?: number;
    borderOpacity?: number;
}

const StyledGlassBox = styled(Box, {
    shouldForwardProp: (prop) => !['blur', 'opacity', 'borderOpacity'].includes(prop as string)
})<GlassBoxProps>(({ theme, blur = 10, opacity = 0.3, borderOpacity = 0.4 }) => ({
    backdropFilter: `blur(${blur}px)`,
    WebkitBackdropFilter: `blur(${blur}px)`,
    backgroundColor: `rgba(255, 255, 255, ${opacity})`,
    border: `1px solid rgba(255, 255, 255, ${borderOpacity})`,
    borderRadius: theme.spacing(2),
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    position: 'relative',

    '& > *': {
        position: 'relative',
        zIndex: 2
    },

    // Dark mode support
    [theme.breakpoints.up('sm')]: {
        backgroundColor: theme.palette.mode === 'dark'
            ? `rgba(0, 0, 0, ${opacity * 0.8})`
            : `rgba(255, 255, 255, ${opacity})`,
        border: theme.palette.mode === 'dark'
            ? `1px solid rgba(255, 255, 255, ${borderOpacity * 0.3})`
            : `1px solid rgba(255, 255, 255, ${borderOpacity})`
    }
}));

const GlassBox = ({ children, ...props }: GlassBoxProps) => {
    return (
        <StyledGlassBox {...props}>
            {children}
        </StyledGlassBox>
    );
};

export default GlassBox;
